import { ReactNode } from 'react';
import { useRowBoundingBox } from '../../../../../../stores/boundingBoxesStore';
import { useImageStoreActions } from '../../../../../../stores/imageStore';
import { MasterDescriptorIdType, RowIdType } from '../../../../../../types';
import { useHighlightsStoreActions } from '../../../../../../stores/highlightStore';
import { HIGHLIGHTER_VARIANT } from '../../../../../../constants/generalConstants';

type MappingsTableRowPropsType = {
    rowId: RowIdType;
    children: ReactNode;
    masterDescriptorId: MasterDescriptorIdType | null;
};

function MappingsTableRow({ children, rowId, masterDescriptorId }: MappingsTableRowPropsType) {
    const rowBoundingBox = useRowBoundingBox(rowId);
    const imageHighlightActions = useImageStoreActions();
    const highlightActions = useHighlightsStoreActions();

    return (
        <tr
            onPointerEnter={() => {
                imageHighlightActions.setCoordinates([{ ...rowBoundingBox, variant: HIGHLIGHTER_VARIANT.PRIMARY }]);
                highlightActions.setDescriptorId(masterDescriptorId);
            }}
            onPointerLeave={() => {
                imageHighlightActions.clearCoordinates();
                highlightActions.setDescriptorId(null);
            }}
        >
            {children}
        </tr>
    );
}

export default MappingsTableRow;
